<script>
import McMenu from "../McMenu.vue";

export default {
  name: "AsideMenu",
  components: {
    McMenu,
  },
  inject: ["$xxMenu", "$$event", "$xxRouter"],
  props: {
    provider: {
      type: Object,
      default: () => ({}),
    },
    iframeModeUrls: {
      type: Array,
      default: () => [],
    },
    platformConfigs: {
      type: Array,
      default: () => [],
    },
    isRtl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuWidth: { collapsedWidth: "0px", originalWidth: "256px" },
      menuRef: null,
      defaultExpandedNames: [],
      path: "/",
    };
  },
  computed: {
    collapseStatus() {
      return this.menuRef ? this.menuRef.getCollapseStatus() : false;
    },
    sourceData() {
      return this.$xxMenu.menuData;
    },
  },
  methods: {
    selectMenu(val) {
      this.$xxMenu.linkTo(val);
    },
  },
};
</script>

<template>
  <mc-menu
    v-if="sourceData"
    ref="menuRef"
    mode="inline"
    :value="path"
    :source="sourceData"
    :menu-width="menuWidth"
    :collapse-status="collapseStatus"
    :default-expanded-names="defaultExpandedNames"
    :router="false"
    @selected="selectMenu"
  >
    <template #top>
      <img
        src="https://img-ap-hongkong.mykeeta.net/osgeujiemo/3bf95be72fb79ca448ee689997ee19a323636.png"
        class="logo-img"
      />
    </template>
  </mc-menu>
</template>

<style>
:root[dir="rtl"] .mc-sidebar .mtd-menu-item-title {
  padding-right: 36px;
  padding-left: 16px;
}

:root[dir="rtl"] .mc-sidebar .mtd-submenu-icon {
  margin-right: 0px;
  margin-left: 8px;
}
</style>

<style scoped>
.side-bar-menu-top {
  line-height: 21px;
  text-align: center;
  padding: 15px 0 5px;
  font-size: 21px;
  display: block;
  color: #fff;
  font-weight: 700;
}

.logo-img {
  width: 224px;
  height: 82px;
  margin-block: 36px;
}

.mc-aside {
  height: 100vh;
}

:deep(.mtd-menu::-webkit-scrollbar) {
  display: none; /* Chrome, Safari */
}

:deep(.mtd-menu-dark) {
  background: #262427;
  color: #fff;
}

:deep(.mtd-submenu-text),
:deep(.mtd-menu-item-text) {
  font-size: 16px;
}

:deep(.mtd-menu .mtd-menu-item-active .mtd-menu-item-title),
:deep(.mtd-menu .mtd-menu-item-active .mtd-menu-item-title.hover),
:deep(.mtd-menu .mtd-menu-item-active .mtd-menu-item-title:hover),
:deep(.mtd-submenu .mtd-submenu-title:hover),
:deep(.mtd-menu-item:hover) {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-weight: 400;
}

:deep(.mtd-menu .mtd-submenu-active > .mtd-tooltip-rel > .mtd-submenu-title) {
  background: #00a854;
  color: #fff;
  font-weight: 500;
}

:deep(.mtd-submenu-title),
:deep(.mtd-menu-item) {
  height: 56px;
  line-height: 56px;
}

:deep(.mtd-submenu-icon) {
  height: 20px;
  line-height: 20px;
}
</style>
